import {DragActions, DragActionTypes} from '../actions/drag.actions';
import {DragStartPayload} from '../models/drag-and-drop';

export interface State {
  dragZone: string | null;
  data: any | null;
  isDragging: boolean;
}

export const initialState: State = {
  dragZone: null,
  data: null,
  isDragging: false
};

export function reducer(state = initialState, action: DragActions): State {
  switch (action.type) {

    case DragActionTypes.DragStart: {
      const dragStartPayload: DragStartPayload = action.payload;
      return {
        ...state,
        dragZone: dragStartPayload.dragZone,
        isDragging: true,
        data: dragStartPayload.data
      };
    }

    case DragActionTypes.DragEnd: {
      return {
        ...state,
        isDragging: false
      };
    }

    default:
      return state;
  }
}

export const dragZone = (state: State) => state.dragZone;
export const draggedData = (state: State) => state.data;
export const isDragging = (state: State) => state.isDragging;
